// eslint-disable-next-line no-unused-vars
import React, { useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';

import SerialNumbers from 'Containers/Service/SerialNumbers';
import RMA from 'Containers/Service/RMA';
import PPWR from 'Containers/Service/PPWR';
import { NWTabsNavigation } from 'Components/shared';

const StyledService = styled.div``;

const ServiceComponent = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const links = useMemo(
    () => [
      {
        to: 'rma',
        label: t('profile.menu.rma')
      },
      {
        to: 'warranties',
        label: t('profile.menu.warranties')
      },
      {
        to: 'ppwr',
        label: t('ppwr.heading')
      },
    ],
    [t]
  );

  return (
    <StyledService theme={ theme }>
      <div className="pageTitle">
        <h3>{ t('common.pages.service') }</h3>
      </div>
      <NWTabsNavigation links={ links } />
      <Routes>
        <Route index element={ <Navigate to="rma" replace /> } />
        <Route path="rma" element={ <RMA /> } />
        <Route path="warranties" element={ <SerialNumbers /> } />
        <Route path="ppwr" element={ <PPWR /> } />
        {/* <Route path="api-information" element={ <APIInformation setErrors={ setErrors } /> } /> */}
        <Route path="*" element={ <Navigate to="/not-found" replace /> } />
      </Routes>
    </StyledService>
  );
};

ServiceComponent.displayName = 'ServiceComponent';

export default ServiceComponent;
